import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import { useValue } from '@morningtrain/react-resources'
import * as moment from 'moment'
import { DurationFromSeconds } from 'support/displays'

function TrackCardTitle () {
  const week = useValue('key')
  const currentWeek = moment().week()

  const active = currentWeek === week

  const classNames = [
    'flex',
    'justify-between',
    'items-center',
    'py-4',
    'px-6',
    'md:py-6',
    'md:px-8',
    'font-medium',
    active ? 'bg-primary-500 text-white' : 'bg-gray-200'
  ]

  return (
    <div className={classNames.join(' ')}>
      <span><Translation name='generic.week_number' data={{ week: week }} /></span>
      <span><DurationFromSeconds name='total_seconds' /></span>
    </div>
  )
}

export default TrackCardTitle
